import {classNames} from 'utils';

interface IProgressBarProps {
  progress: number;
  progressMax?: number;
  progressSuffix?: string;
  progressText?: string;
  size?: 'normal' | 'small';
}

const ProgressBar = ({progress, progressMax = 100, progressSuffix = '%', progressText = '', size = 'normal'}: IProgressBarProps) => {
  const progressValue = Math.min((progress / progressMax) * 100, 100);
  const progressHeight = size === 'normal' ? 'h-4' : 'h-2';
  return (
    <div className="flex flex-col gap-3 w-full max-w-xs justify-center items-center select-none">
      <div className={classNames('w-full bg-gray-300 rounded-md overflow-hidden', progressHeight)}>
        <div className={classNames('bg-primary rounded-md', progressHeight)} style={{width: `${progressValue}%`}}></div>
      </div>
      <p className="text-sm/6 text-gray-700 dark:text-darkText">
        {progressText ? `${progressText} ` : ''}
        {progress} / {progressMax}
        {progressSuffix}
      </p>
    </div>
  );
};

export default ProgressBar;
